var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable react/react-in-jsx-scope */
import { ELSCommonUIConstants } from 'components/common';
import { analyticBaseConfig } from 'config/app.config';
import { ROUTE_ROLES, RoutePath } from 'constants/app.constant';
import { lazy } from 'react';
var INSTRUCTOR = ROUTE_ROLES.INSTRUCTOR, STUDENT = ROUTE_ROLES.STUDENT;
export var AppRoutes = {
    getRoutes: function () { return __spreadArray(__spreadArray([], [RoutePath.cwStu, RoutePath.student.home].map(function (route) { return ({
        path: route,
        component: lazy(function () { return import('reports/cw/components/pages/student-role/student-home/StudentHome'); }),
        data: {
            analytics: {
                pageType: ELSCommonUIConstants.analytics.pageTypes.home,
                pageName: "".concat(analyticBaseConfig.edApp, ":cw-student-home")
            }
        },
        isPrivate: true,
        roles: STUDENT
    }); }), true), [RoutePath.cwIns, RoutePath.home].map(function (route) { return ({
        path: route,
        component: lazy(function () { return import('reports/cw/components/pages/instructor-home/InstructorHomeComponent'); }),
        data: {
            analytics: {
                pageType: ELSCommonUIConstants.analytics.pageTypes.home,
                pageName: "".concat(analyticBaseConfig.edApp, ":cw-instructor-home")
            }
        },
        isPrivate: true,
        roles: INSTRUCTOR
    }); }), true); }
};
